import moment from 'moment';
export const ISO_DATE_FORMAT = 'yyyy-MM-DD';
export const DEFAULT_DATE_FORMAT = 'MMM DD, yyyy';
export const COMPLETE_DATE_FORMAT = 'ddd MMM DD, yyyy';
export const DEFAULT_MONTH_DATE_FORMAT = 'DD MMM, yyyy';
export const MONTH_YEAR_FORMAT = 'MMM, YYYY';

export const formatDate = (
  value: Date | string | number,
  format: string = DEFAULT_DATE_FORMAT,
): string => {
  const formatted = moment(value).format(format);
  return formatted;
};

export const formatPeriod = (period: Date[], conjunction = 'to'): string => {
  if (period.length === 1) {
    return moment(period[0]).format(DEFAULT_DATE_FORMAT);
  }
  if (period.length > 1) {
    const startDate = moment(period[0]).format(DEFAULT_DATE_FORMAT);
    const endDate = moment(period[1]).format(DEFAULT_DATE_FORMAT);
    if (startDate !== endDate) {
      return `${startDate} ${conjunction} ${endDate}`;
    } else {
      return `${endDate}`;
    }
  }
  return '';
};
